import script from "./ClientMasters.vue?vue&type=script&setup=true&lang=js"
export * from "./ClientMasters.vue?vue&type=script&setup=true&lang=js"

import "./ClientMasters.vue?vue&type=style&index=0&id=51e009c8&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-51e009c8"]])

export default __exports__